// noticeWhen is how long ago a notification came, in words that stay true
// while she reads them: "Just now", "5m ago", "3h ago" for today, "Yesterday",
// then the date ("Wed 22 Oct"). Days are her device's local days.
export function noticeWhen(at: string, now: Date = new Date()): string {
  const then = new Date(at)
  const minutes = Math.floor((now.getTime() - then.getTime()) / 60000)
  if (minutes < 1) return 'Just now'
  if (minutes < 60) return `${minutes}m ago`

  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate())
  const daysBack = Math.round((startOfDay(now).getTime() - startOfDay(then).getTime()) / 86400000)
  if (daysBack <= 0) return `${Math.floor(minutes / 60)}h ago`
  if (daysBack === 1) return 'Yesterday'
  return then.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' })
}
